<template>
  <div>
    <div>
      <h3 class="menu-title">{{ $t('menu') }}</h3>
      <div @click="$emit('changePage', 'MeetingDetailInfo')" class="relative">
        <div
          :class="activeMenuClass('meeting_detail')"
          @click="activeMenuHandler('meeting_detail')"
          class="menu-item"
          @mouseover="infoToolTip = true"
          @mouseleave="infoToolTip = false"
        >
          <circle-info width="24" height="24" class="mx-16" />
        </div>
        <div v-if="infoToolTip" class="tooltip">
          <p>{{ $t('info') }}</p>
        </div>
      </div>
    </div>
    <div
      class="relative"
      @click="$emit('changePage', 'EditMeeting')"
      v-if="meetingInfo.can_edit_meeting"
    >
      <div
        :class="activeMenuClass('edit_meeting')"
        @click="activeMenuHandler('edit_meeting')"
        class="menu-item"
        @mouseover="editToolTip = true"
        @mouseleave="editToolTip = false"
      >
        <edit-navigation width="24" height="24" class="mx-16" />
      </div>
      <div v-if="editToolTip" class="tooltip">
        <p>{{ $t('edit') }}</p>
      </div>
    </div>
    <div
      v-if="meetingInfo.unread_message !== null"
      class="relative"
      @click="$emit('changePage', 'MeetingChat')"
    >
      <div
        :class="activeMenuClass('discussion')"
        @click="activeMenuHandler('discussion'); unreadMessages = 0"
        class="menu-item"
        @mouseover="chatToolTip = true"
        @mouseleave="chatToolTip = false"
      >
        <div class="unread-messages-count" v-if="unreadMessages > 0" dir="auto">
          {{ unreadMessages > 99 ? '+99' : unreadMessages }}
        </div>

        <MessageIcon width="24" height="24" class="mx-16" />
        <div v-if="chatToolTip" class="tooltip">
          <p>{{ $t('discussion') }}</p>
        </div>
      </div>
    </div>
    <div class="relative">
      <div
        class="menu-item"
        @mouseover="shareToolTip = true"
        @mouseleave="shareToolTip = false"
        @click="shareToolTip = false"
      >
        <export
          width="24"
          height="24"
          class="mx-16"
          @click.native="$store.dispatch('modal/open', 'shareMeeting')"
        />
        <share-meeting
          :meetingInfo="meetingInfo"
          :newFormatDateStart="newFormatDateStart"
          :newFormatDateEnd="newFormatDateEnd"
          :calendar="calendar"
        />
      </div>
      <div v-if="shareToolTip" class="tooltip">
        <p>{{ $t('share') }}</p>
      </div>
    </div>
    <div
      @click="$emit('changePage', 'DuplicateMeeting')"
      class="relative"
      v-if="meetingInfo.can_copy_meeting"
    >
      <div
        :class="activeMenuClass('duplicate_meeting')"
        @click="activeMenuHandler('duplicate_meeting')"
        class="menu-item"
        @mouseover="duplicateToolTip = true"
        @mouseleave="duplicateToolTip = false"
      >
        <copy width="24" height="24" class="mx-16" />
      </div>
      <div v-if="duplicateToolTip" class="tooltip">
        <p>{{ $t('duplicate') }}</p>
      </div>
    </div>
    <!-- REMINDER ICON -->
    <div v-if="PrevMeeting" @click="$emit('changePage', 'CustomReminder')" class="relative">
      <div
        :class="activeMenuClass('reminder')"
        @click="activeMenuHandler('reminder')"
        class="menu-item"
        @mouseover="customReminder = true"
        @mouseleave="customReminder = false"
      >
        <reminder-icon width="24" height="24" class="mx-16" />
      </div>
      <div v-if="customReminder" class="tooltip">
        <p>{{ $t('reminder') }}</p>
      </div>
    </div>
    <div v-if="activeDetail && meetingInfo.can_extend_meeting" class="relative">
      <div
        class="menu-item"
        @mouseover="extendToolTip = true"
        @mouseleave="extendToolTip = false"
        @click="extendToolTip = false"
      >
        <extend
          width="24"
          height="24"
          class="mx-16"
          @click.native="$store.dispatch('modal/open', 'extendMeeting')"
        />
        <extend-meeting
          :meetingInfo="meetingInfo"
          @updateMeetingInfo="$emit('updateMeetingInfo')"
        />
      </div>
      <div v-if="extendToolTip" class="tooltip">
        <p>{{ $t('extend') }}</p>
      </div>
    </div>
    <div>
      <div class="relative">
        <div
          class="menu-item"
          @mouseover="deleteToolTip = true"
          @mouseleave="deleteToolTip = false"
          @click="deleteToolTip = false"
        >
          <receive-square
            :color="theme === 'light' ? 'var(--color-danger)' : 'var(--color-danger)'"
            width="24"
            height="24"
            class="mx-16"
            v-if="meetingInfo.can_end_meeting && activeDetail"
            @click.native="openMeetingDeleteModal()"
          />
          <trash
            v-else-if="meetingInfo.can_delete_meeting && !activeDetail"
            width="24"
            height="24"
            class="mx-16"
            :color="theme === 'light' ? 'var(--color-danger)' : 'var(--color-danger)'"
            @click.native="openMeetingDeleteModal()"
          />
          <div v-if="deleteToolTip && !activeDetail" class="tooltip">
            <p>{{ $t('delete') }}</p>
          </div>
          <div v-if="deleteToolTip && activeDetail" class="tooltip">
            <p>{{ $t('end') }}</p>
          </div>
          <end-meeting-modal
            :activeDetail="activeDetail"
            @endMeeting="endMeetingHandler"
            @deleteMeeting="deleteMeetingHandler"
          />
          <delete-recurring-meeting @removeRecurringMeeting="deleteMeetingHandler" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleInfo from '@/assets/icons/vue/CircleInfo.vue';
import Extend from '@/assets/icons/vue/Extend.vue';
import ReminderIcon from '@/assets/icons/vue/notification.vue';
import ReceiveSquare from '@/assets/icons/vue/receive-square.vue';
import EditNavigation from '@/assets/icons/vue/editNavigation.vue';
import MessageIcon from '@/assets/icons/vue/Message.vue';
import Export from '@/assets/icons/vue/Export.vue';
import Copy from '@/assets/icons/vue/copy.vue';
import Trash from '@/assets/icons/vue/trash.vue';
import axiosConfig from '@/services/axios.config';
import serverErrorsHandler from '@/utils/serverErrorsHandler';
import { mapGetters } from 'vuex';
import ExtendMeeting from '@/views/conference/ExtendMeeting.vue';
import EndMeetingModal from '@/views/conference/EndMeetingModal.vue';
import ShareMeeting from '@/views/conference/ShareMeeting.vue';
import DeleteRecurringMeeting from '@/views/conference/modals/DeleteRecurringMeeting.vue';

export default {
  name: 'MeetingDetailSidebar',
  components: {
    CircleInfo,
    ReminderIcon,
    EditNavigation,
    MessageIcon,
    Export,
    Copy,
    Trash,
    EndMeetingModal,
    ReceiveSquare,
    ShareMeeting,
    Extend,
    ExtendMeeting,
    DeleteRecurringMeeting,
  },
  props: {
    meetingInfo: {
      type: Object,
    },
    activePage: {
      type: String,
      default: 'meeting_detail',
    },
    newFormatDateStart: {
      type: String,
    },
    newFormatDateEnd: {
      type: String,
    },
    calendar: {
      type: String,
    },
  },
  data() {
    return {
      activeMenuItem: '',
      meetingInfoID: this.$route.params.reserveId,
      companyId: this.$route.params.companyId,
      deviceId: this.$route.params.deviceId,
      reserveId: this.$route.params.reserveId,
      date: new Date().toISOString().split('T')[0],
      infoToolTip: false,
      editToolTip: false,
      shareToolTip: false,
      duplicateToolTip: false,
      customReminder: false,
      extendToolTip: false,
      chatToolTip: false,
      deleteToolTip: false,
      reservations: [],
      activeDetail: false,
      startTime: 0,
      unreadMessages: 0,
      endTime: 0,
      PrevMeeting: false,
      currentTime: new Date(),
      isMeetingRepetitive: false,
    };
  },
  computed: {
    ...mapGetters({ theme: 'getTheme', defaultCompany: 'getDefaultCompany' }),
  },
  watch: {
    meetingInfo(Val) {
      this.startTime = new Date(Val.started_at);
      this.endTime = new Date(Val.ended_at);
      this.isMeetingRepetitive = Val.is_repetitive;
      this.unreadMessages = Val.unread_message;
      this.checkOngoingMeeting();
      this.checkPrevMeeting();
    },
  },
  created() {
    this.activeMenuItem = this.activePage;
  },
  mounted() {
    this.todayMilliseconds = Date.parse(this.currentDate);
  },
  methods: {
    openMeetingDeleteModal() {
      if (this.isMeetingRepetitive && !this.activeDetail) {
        this.$store.dispatch('modal/open', 'deleteRecurringMeeting');
      } else {
        this.$store.dispatch('modal/open', 'endMeetingModal');
      }
    },
    checkOngoingMeeting() {
      if (this.startTime <= this.currentTime && this.endTime >= this.currentTime) {
        this.activeDetail = true;
      } else {
        this.activeDetail = false;
      }
    },
    checkPrevMeeting() {
      if (this.currentTime > this.endTime) {
        this.PrevMeeting = false;
      } else {
        this.PrevMeeting = true;
      }
    },
    closeModals(...modals) {
      modals.map((modalName) => this.$store.dispatch('modal/close', modalName));
    },
    deleteMeetingHandler(data) {
      this.$store.commit('loading/DISABLE_HANDLER', true);
      axiosConfig
        .delete(
          `/companies/${this.companyId || this.meetingInfo.company_id}/reservations/${this.meetingInfoID || this.meetingInfo.id}/delete-meeting?repeat[confirm]=${data || 'one'}`,
          { device_id: this.deviceId },
        )
        .then(() => {
          this.$toast.success(this.$t('deleted'));
          this.closeModals('endMeeting');
          this.closeModals('deleteRecurringMeeting');
          this.$store.commit('loading/DISABLE_HANDLER', false);
          if (this.deviceId) {
            this.$router.push({
              name: 'ConferenceRoom',
              params: { locale: this.$i18n.locale, id: this.deviceId },
            });
          } else {
            this.$router
              .push({
                name: 'UserCalendar',
                params: { locale: this.$i18n.locale },
              })
              .catch(() => {});
          }
        })
        .catch((error) => {
          this.closeModals('endMeeting');
          serverErrorsHandler(error);
          this.$store.commit('loading/DISABLE_HANDLER', false);
        });
    },
    endMeetingHandler() {
      this.$store.commit('loading/DISABLE_HANDLER', true);
      axiosConfig
        .post(`/companies/${this.companyId || this.meetingInfo.company_id}/reservations/${this.meetingInfoID || this.meetingInfo.id}/end-meeting`, {
          device_id: this.deviceId,
        })
        .then(() => {
          this.$toast.success(this.$t('ended'));
          this.closeModals('endMeeting');
          this.$store.commit('loading/DISABLE_HANDLER', false);
          this.$router.push({ name: 'ConferenceRoom', params: { id: this.deviceId } });
          if (this.deviceId) {
            this.$router.push({
              name: 'ConferenceRoom',
              params: { locale: this.$i18n.locale, id: this.deviceId },
            });
          } else {
            this.$router
              .push({
                name: 'UserCalendar',
                params: { locale: this.$i18n.locale },
              })
              .catch(() => {});
          }
        })
        .catch((error) => {
          this.closeModals('endMeeting');
          serverErrorsHandler(error);
          this.$store.commit('loading/DISABLE_HANDLER', false);
        });
    },
    activeMenuHandler(menuItem) {
      this.activeMenuItem = menuItem;
    },
    activeMenuClass(menuItem) {
      return this.activeMenuItem === menuItem ? 'active-item' : '';
    },
  },
};
</script>

<style lang="css" scoped>
.active-item {
  @apply bg-primaryOpacity border-l-3 border-primary transition-all duration-150;
}
.active-item:is(:lang(fa), :lang(ar)) {
  @apply bg-primaryOpacity border-l-0 border-r-3 border-primary transition-all duration-150;
}
.menu-title {
  @apply font-medium text-title mb-10 mx-17.6;
}
.menu-item {
  @apply flex items-center justify-center rounded-md rounded-l-none cursor-pointer py-13;
}
.menu-item:is(:lang(fa), :lang(ar)) {
  @apply flex items-center rounded-md rounded-r-none cursor-pointer py-13;
}
.tooltip {
  @apply absolute w-max text-center -right-98 left-auto top-10
   bg-tertiary px-10 py-5 rounded-sm z-20;
}
.tooltip:after {
  content: '';
  @apply absolute top-1/2 right-full left-auto -mt-5 border-4 border-solid;
  border-color: transparent var(--color-bg-tertiary) transparent transparent;
}
.tooltip:is(:lang(fa), :lang(ar)) {
  @apply absolute w-118 text-center -left-128 right-auto
   top-10 bg-tertiary px-10 py-5 rounded-sm z-20;
}
.tooltip:is(:lang(fa), :lang(ar)):after {
  content: '';
  @apply absolute top-1/2 left-full right-auto -mt-5 border-4 border-solid;
  border-color: transparent transparent transparent var(--color-bg-tertiary);
}
.unread-messages-count {
  @apply bg-primaryColor rounded-full text-center text-onPrimaryButton text-12 w-22 h-22 absolute
   top-2 left-26 leading-6;
}
</style>
